define('drops/baiduMaps/baiduMaps',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style'
], function ($, _, Drop, Style) {
    'use strict';

    var bmStatuses = {
        notReady: 'notReady',
        loading: 'loading',
        ready: 'ready',
        apiKey: null
    };

    var bmStatus = bmStatuses.notReady;
    var bmReadyCallbacks = [];

    var waitForBaiduMaps = function (callback) {
        bmReadyCallbacks.push(callback);
    };

    var loadBaiduMaps = function (apiKey, callback) {
        waitForBaiduMaps(callback);

        window.baiduMapsReady = function () {
            _.each(bmReadyCallbacks.splice(0, bmReadyCallbacks.length), function (callback) {
                callback();
            });
        };
        
        var jsFile = 'https://api.map.baidu.com/api?v=2.0&s=1&callback=baiduMapsReady&ak=' + apiKey;
        $.getScript(jsFile);

        bmStatus = bmStatuses.loading;
    };

    var defaults = {
        data: {
            mapType: 'BMAP_NORMAL_MAP',
            size: { x: 500, y: 500 },
            showMapTypeButtons: false,
            locationType: 'city',
            city: '北京',
            defaultZoom: 10
        }
    };

    function BaiduMaps(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.$element
            .addClass('boxToBorderSize');

        this.$map = $('<div />')
            .css({
                width: '100%',
                height: '100%'
            })
            .appendTo(this.$element);

        Style.renderStyles(this);

        this.usable = false;
    };

    Drop.extend(BaiduMaps, Drop);

    BaiduMaps.typeName = 'BaiduMaps';

    BaiduMaps.prototype.preRender = function () {
        this.applyPosition();
    };

    BaiduMaps.prototype.postRender = function () {
        this.renderMap();
    };

    BaiduMaps.prototype.renderMap = function () {
        if (!this.data.apiKey) return;

        if (bmStatus === bmStatuses.notReady) {
            loadBaiduMaps(this.data.apiKey, this.onReady.bind(this));
        } else if (bmStatus === bmStatuses.loading) {
            waitForBaiduMaps(this.onReady.bind(this));
        } else {
            this.onReady();
        }

        this.usable = true;
    };

    BaiduMaps.prototype.onReady = function () {
        this.map = new window.BMap.Map(this.$map[0], {
            mapType: this.getMapType()
        });
        this.map.enableScrollWheelZoom(true);
        this.map.enablePinchToZoom();

        this.toggleMapTypeControl();
        this.toggleNavigationControl();

        this.updateLocation();
    };

    BaiduMaps.prototype.updateLocation = function () {
        if (this.data.locationType === 'city' && this.data.showDefaultCity)
            this.openCity(this.data.city);
        else if (this.data.locationType === 'address' && this.data.showDefaultAddress)
            this.openAddress(this.data.address);
        else if (this.data.locationType === 'gpsCoordinates' && this.data.showDefaultGpsLocation)
            this.openGpsCoordinates(this.data.gpsLongitude, this.data.gpsLatitude);
        else if (this.data.locationType === 'bd09Coordinates' && this.data.showDefaultBd09Location)
            this.openBaiduCoordinates(this.data.bd09Longitude, this.data.bd09Latitude);
        else if (this.data.locationType === 'userCoordinates')
            this.openLocationOfUser();
        else if (this.data.locationType === 'userCity')
            this.openCityOfUser();
    };

    BaiduMaps.prototype.toggleMapTypeControl = function () {
        if (this.data.showMapTypeButtons) {
            if (!this.mapTypeControl)
                this.mapTypeControl = new window.BMap.MapTypeControl();
            this.map.addControl(this.mapTypeControl);
        } else if (this.mapTypeControl) {
            this.map.removeControl(this.mapTypeControl);
        }
    };

    BaiduMaps.prototype.toggleNavigationControl = function () {
        if (this.data.showNavigationControl) {
            if (!this.navigationControl)
                this.navigationControl = new window.BMap.NavigationControl();
            this.map.addControl(this.navigationControl);
        } else if (this.navigationControl) {
            this.map.removeControl(this.navigationControl);
        }
    };

    BaiduMaps.prototype.openCity = function (city) {
        this.map.setCurrentCity(city);
        this.map.centerAndZoom(city, this.data.defaultZoom);
    };

    BaiduMaps.prototype.openAddress = function (address) {
        var geoAddress = new window.BMap.Geocoder();

        var self = this;
        geoAddress.getPoint(address,
            function (point) {
                if (!point) return;

                self.map.centerAndZoom(point, self.data.defaultZoom);
            });
    };

    BaiduMaps.prototype.openBaiduCoordinates = function (longitude, latitude) {
        var point = new window.BMap.Point(longitude, latitude);
        this.map.centerAndZoom(point, this.data.defaultZoom);
    };

    BaiduMaps.prototype.openGpsCoordinates = function (longitude, latitude) {
        var points = [new window.BMap.Point(longitude, latitude)];
        var convertor = new window.BMap.Convertor();
        
        var self = this;
        convertor.translate(points,
            1, // from GPS
            5, // to Baidu
            this.data.apiKey,
            function (data) {
                if (data.status !== 0) return;
                self.map.centerAndZoom(data.points[0], self.data.defaultZoom);
            });
    };

    BaiduMaps.prototype.openLocationOfUser = function () {
        var geolocation = new window.BMap.Geolocation();

        var self = this;
        geolocation.getCurrentPosition(function (r) {
            if (this.getStatus() !== window.BMAP_STATUS_SUCCESS) return;
            self.map.centerAndZoom(r.point, self.data.defaultZoom);
        }, { enableHighAccuracy: true });
    };

    BaiduMaps.prototype.openCityOfUser = function () {
        var theCity = new window.BMap.LocalCity();

        var self = this;
        theCity.get(function (result) {
            self.map.setCurrentCity(result.name);
            self.map.centerAndZoom(result.name, self.data.defaultZoom);
        });
    };

    BaiduMaps.prototype.clearValue = $.noop;

    BaiduMaps.prototype.setValue = function (update) {
        switch(this.data.locationType) {

            case 'city':
                this.openCity(update.value);
                break;

            case 'address':
                this.openAddress(update.value);
                break;

            case 'gpsCoordinates':
                var gpsParts = update.value.split(',');
                this.openGpsCoordinates(gpsParts[0], gpsParts[1]);
                break;

            case 'bd09Coordinates':
                var baiduParts = update.value.split(',');
                this.openBaiduCoordinates(baiduParts[0], baiduParts[1]);
                break;

        }
    };
    
    BaiduMaps.prototype.getMapType = function () {
        return window[this.data.mapType];
    };

    return BaiduMaps;
});
